import {definePreset} from '@primevue/themes'
import Aura from '@primevue/themes/aura'

const primary = {
    50: '{green.50}',
    100: '{green.100}',
    200: '{green.200}',
    300: '{green.300}',
    400: '{green.400}',
    500: '{green.500}',
    600: '{green.600}',
    700: '{green.700}',
    800: '{green.800}',
    900: '{green.900}',
    950: '{green.950}'
}

const surface = {
    0: '#ffffff',
    50: '#f3f3f3',
    100: '#e7e7e8',
    200: '#cfd0d0',
    300: '#b7b8b9',
    400: '#9fa1a1',
    500: '#87898a',
    600: '#6e7173',
    700: '#565a5b',
    800: '#3e4244',
    900: '#262b2c',
    950: '#0e1315'
}
export const Noir = definePreset(Aura, {
    semantic: {
        primary,
        colorScheme: {
            light: { surface },
            dark: { surface }
        },
    },
    // 2025-09-08-kjetil Example of style override toast, visibility for invoice toast (dark mode)
    // components: {
    //     toast: {
    //         colorScheme: {
    //             dark: {
    //                 error: {
    //                     background: '{red.500}',
    //                     color: '{white}'
    //                 },
    //                 success: {
    //                     background: '{green.500}',
    //                     color: '{white}'
    //                 },
    //                 warn: {
    //                     background: '{yellow.600}',
    //                     color: '{white}'
    //                 },
    //                 info: {
    //                     background: '{blue.500}',
    //                     color: '{white}'
    //                 },
    //             }
    //         }
    //     }
    // }
})